module.exports = __webpack_public_path__ + "images/stickers/taco-alert@2x.a5465d28947b51ca12ca.png";